import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, byteSize } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './maintenance-review.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MaintenanceReviewDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const maintenanceReviewEntity = useAppSelector(state => state.maintenanceReview.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="maintenanceReviewDetailsHeading">
          <Translate contentKey="fleetSenseApp.maintenanceReview.detail.title">MaintenanceReview</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{maintenanceReviewEntity.id}</dd>
          <dt>
            <span id="reviewOrder">
              <Translate contentKey="fleetSenseApp.maintenanceReview.reviewOrder">Review Order</Translate>
            </span>
          </dt>
          <dd>{maintenanceReviewEntity.reviewOrder}</dd>
          <dt>
            <span id="km">
              <Translate contentKey="fleetSenseApp.maintenanceReview.km">Km</Translate>
            </span>
          </dt>
          <dd>{maintenanceReviewEntity.km}</dd>
          <dt>
            <span id="period">
              <Translate contentKey="fleetSenseApp.maintenanceReview.period">Period</Translate>
            </span>
          </dt>
          <dd>{maintenanceReviewEntity.period}</dd>
          {/*
          <dt>
            <span id="hour">
              <Translate contentKey="fleetSenseApp.maintenanceReview.hour">Hour</Translate>
            </span>
          </dt>
          <dd>{maintenanceReviewEntity.hour}</dd>
          */}
          <dt>
            <span id="description">
              <Translate contentKey="fleetSenseApp.maintenanceReview.description">Description</Translate>
            </span>
          </dt>
          <dd>{maintenanceReviewEntity.description}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.maintenanceReview.maintenanceModel">Maintenance Model</Translate>
          </dt>
          <dd>{maintenanceReviewEntity.maintenanceModel ? maintenanceReviewEntity.maintenanceModel.name : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.maintenanceReview.company">Company</Translate>
          </dt>
          <dd>{maintenanceReviewEntity.company ? maintenanceReviewEntity.company.name : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.maintenanceReview.part">Part</Translate>
          </dt>
          <dd>
            {maintenanceReviewEntity.parts
              ? maintenanceReviewEntity.parts.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.name}</a>
                    {maintenanceReviewEntity.parts && i === maintenanceReviewEntity.parts.length - 1 ? '' : ', '}
                  </span>
                ))
              : null}
          </dd>
        </dl>
        <Button tag={Link} to="/maintenance-review" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/maintenance-review/${maintenanceReviewEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MaintenanceReviewDetail;
